import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets window scroll to the top whenever the route pathname changes,
 * unless the URL contains a hash (in which case the target page is expected
 * to scroll smoothly to that section itself).
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return; // hash-scroll handled by destination page
    // Use 'auto' to avoid a long smooth-scroll animation on full page changes
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
}
